import { render, staticRenderFns } from "./OrdersMapSummary.vue?vue&type=template&id=5077d148"
import script from "./OrdersMapSummary.vue?vue&type=script&lang=js"
export * from "./OrdersMapSummary.vue?vue&type=script&lang=js"
import style0 from "./OrdersMapSummary.vue?vue&type=style&index=0&id=5077d148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports